<div class="flex flex-col h-full p-4 overflow-hidden">
    <div class="flex flex-col flex-shrink-0 mb-4">
        <div class="flex items-center text-sm mb-3">
            <div class="cursor-pointer" (click)="goBack()">
                <i class="pi pi-chevron-left"></i>
                <span class="font-bold ml-2">Consumption Details</span>
            </div>
            <div class="flex flex-1 justify-end items-center gap-4">
                <div class="flex gap-3 flex-shrink-0 items-center">
                    @if(organizationId){
                    <app-multi-select [options]="allUsers" [(value)]="selectedUserIds" optionLabel="name"
                        optionValue="value"
                        [config]="{placeholder: 'Select users', style: {'width': '20rem'}, overlayOptions: {styleClass: 'white-bg-overlay'}}"
                        (onHide)="userChange()" (onChange)="userChange()">
                    </app-multi-select>
                    }
                    <app-datepicker [(value)]="rangeDates" [config]="{
                        selectionMode: 'range',
                        iconDisplay: 'input',
                        showIcon: true,
                        maxDate: maxDate
                    }" (onClose)="dateChange()" />
                </div>
            </div>
        </div>
    </div>
    <div class="flex-1 overflow-hidden">
        <app-data-table [data]="rowData" [columns]="consumptionColumns" [config]="consumptionTableConfig"
            tableClass="consumption-details-table">
        </app-data-table>
    </div>
</div>
